import { Modal, TableRow } from "@mui/material";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";
import TextBox from "../../../../shared/components/TextBox";
import IconButton from "../../../../shared/components/IconButton";
import DeleteIcon from "../../../../shared/svg/DeleteIcon";
import { Provider } from "../../../../data/entities";
import React, { useEffect, useState } from "react";
import { api } from "../../../../shared/hooks/api";
import { StyledBackdrop } from "../../../../shared/components/CancelModal/Styled";
import {
    ButtonRow,
    Expandable,
    InfoText,
    ModalWrapper,
    TitleText,
    TitleWrapper,
} from "../../../Provider/create/Content/MaterialList/AddMaterialModal/Styled";
import SearchBarWithSuggestion from "../../../../shared/components/SearchBar/SearchBarWithSuggestion";
import CustomTable from "../../../../shared/components/CustomTable";
import { ProviderLinkMaterialTableColumns } from "../../../../configs/provider";
import CustomButton from "../../../../shared/components/TitleRow/CustomButton";
import { ContactInfo, ContactName } from "../../../ProviderList/Content/CustomTable/Styled";
import { formatInternationalNumber, parseInternationalToNumber } from "../../../../utils/format";
import { error } from "../../../../utils/toast";

interface ProviderRowProps {
    item: any;
    extraRowProps: any;
}

const ProviderRow = ({ item, extraRowProps }: ProviderRowProps) => {
    const price = item.price ? item.price : 0;
    const note = item.note !== undefined ? item.note : "";

    const ContactDetail = () => {
        // Ensure contact_list is an array
        if (!Array.isArray(item.contact_list) || item.contact_list.length === 0) return "Chưa có";

        const contactPerson = item.contact_list.find(
            (contact: any) => contact.contact.is_default,
        );

        return (
            <>
                <ContactName>{contactPerson?.contact.name}</ContactName>
                {contactPerson?.contact.phone && (
                    <>
                        {" "}
                        -{" "}
                        <ContactInfo>
                            {contactPerson?.contact.phone}
                        </ContactInfo>
                    </>
                )}
                {contactPerson?.contact.email && (
                    <>
                        {" "}
                        -{" "}
                        <ContactInfo>
                            {contactPerson?.contact.email}
                        </ContactInfo>
                    </>
                )}
            </>
        );
    };

    return (
        <TableRow>
            <StyledTableCell align="left">{item.name}</StyledTableCell>
            <StyledTableCell align="left">{ContactDetail()}</StyledTableCell>
            <StyledTableCell align="left">
                <TextBox
                    numeric
                    text={formatInternationalNumber(price ?? "")}
                    onChangeText={(value: string) => {
                        const n = parseInternationalToNumber(value, error);
                        if (!Number.isFinite(n)) return;
                        extraRowProps.onChangeMaterialPrice(item, n);
                    }}
                />
            </StyledTableCell>
            <StyledTableCell align="left">
                <TextBox
                    text={note}
                    onChangeText={(value: string) =>
                        extraRowProps.onChangeMaterialNote(item, value)
                    }
                />
            </StyledTableCell>
            <StyledTableCell align="left">
                <IconButton onClick={() => extraRowProps.removeItem(item)}>
                    <DeleteIcon />
                </IconButton>
            </StyledTableCell>
        </TableRow>
    );
};

interface AddProviderModalProps {
    selectedProviders: Provider[];
    open: boolean;
    handleClose: any;
    mergeMaterial: Function;
}

const AddProviderModal = ({
                              selectedProviders,
                              open,
                              handleClose,
                              mergeMaterial,
                          }: AddProviderModalProps) => {
    const [isOpen, setIsOpen] = useState(open);
    const [{ data, variables, error }, fetchMaterials] = api.get(
        "/materials/providers/",
    );
    const [selectedItems, setSelectedItems] =
        useState<Provider[]>(selectedProviders);

    const providers = data && data.results ? data.results : [];
    const totalItems = data && data.count ? data.count : 0;

    const tableItems = selectedItems.length === 0 ? [] : [...selectedItems];

    const onRemoveProvider = (removedProvider: Provider) => {
        const removedProviders = selectedItems.filter(
            (provider) => provider.id !== removedProvider.id,
        );
        setSelectedItems(removedProviders);
    };

    const onUpdateProviderPrice = (provider: Provider, price: number) => {
        const updatedProviders = selectedItems.map((item) => {
            if (item.id === provider.id) return { ...item, price: price };
            return item;
        });
        setSelectedItems(updatedProviders);
    };

    const handleOnClickItem = (item: Provider, isAdded: boolean) => {
        const isItemContained = selectedItems.some(
            (selectedItem) => selectedItem.name === item.name,
        );
        if (isAdded && !isItemContained) {
            setSelectedItems([...selectedItems, item]);
        } else if (!isAdded && isItemContained) {
            onRemoveProvider(item);
        }
    };

    const onUpdateProviderNote = (provider: Provider, note: string) => {
        const updatedProviders = selectedItems.map((item) => {
            if (item.id === provider.id) return { ...item, note };
            return item;
        });
        setSelectedItems(updatedProviders);
    };

    const onClickAddProviders = () => {
        mergeMaterial({ providers: selectedItems });
        handleClose();
    };

    const handleCloseWithAnimation = () => {
        setIsOpen(false);
        setTimeout(handleClose, 200);
    };

    useEffect(() => {
        if (open) {
            setIsOpen(true);
        } else {
            const timer = setTimeout(() => setIsOpen(false), 200);
            return () => clearTimeout(timer);
        }
    }, [open]);

    return (
        <Modal
            open={isOpen}
            onClose={handleCloseWithAnimation}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <ModalWrapper isOpen={isOpen}>
                <Expandable>
                    <TitleWrapper>
                        <TitleText>Thêm nhà cung cấp</TitleText>
                        <InfoText>Vui lòng lựa chọn nhà cung cấp</InfoText>
                    </TitleWrapper>

                    <SearchBarWithSuggestion
                        menuList={providers}
                        selectedItems={selectedItems}
                        fetchItems={(variables: any) =>
                            fetchMaterials({
                                ...variables,
                                page_size: totalItems,
                            })
                        }
                        handleOnclickItem={handleOnClickItem}
                    />

                    <CustomTable
                        itemList={tableItems}
                        RowElement={ProviderRow}
                        TableColumns={ProviderLinkMaterialTableColumns}
                        extraRowProps={{
                            removeItem: onRemoveProvider,
                            onChangeMaterialPrice: onUpdateProviderPrice,
                            onChangeMaterialNote: onUpdateProviderNote,
                        }}
                    />
                </Expandable>

                <ButtonRow>
                    <CustomButton
                        title="Huỷ Bỏ"
                        onClick={handleCloseWithAnimation}
                    />
                    <CustomButton
                        title="Lưu nhà cung cấp"
                        variant="contained"
                        onClick={onClickAddProviders}
                    />
                </ButtonRow>
            </ModalWrapper>
        </Modal>
    );
};

export default AddProviderModal;
